export const trackEvent = (eventName, properties = {}) => {
  if (window.siteTooling?.trackEvent) {
    window.siteTooling.trackEvent(eventName, {
      page: window.location.pathname,
      ...properties,
    });
  }
};

export const trackPageview = (path) => {
  if (window.siteTooling?.trackPageView) {
    window.siteTooling.trackPageView(path || window.location.pathname);
  }
};

export const useSiteTooling = () => ({ trackEvent, trackPageview });
